import { render } from "./CustomizedTriggerButtonOfNewTab.vue?vue&type=template&id=565d572e"
import script from "./CustomizedTriggerButtonOfNewTab.vue?vue&type=script&lang=js"
export * from "./CustomizedTriggerButtonOfNewTab.vue?vue&type=script&lang=js"
script.render = render

export default script